// shared/MetricCard.jsx
// Reusable metric display card with trend and tooltip support
// Extracted from CompetitiveAnalysisView.jsx for better reusability

import React from 'react';

/**
 * Metric display card with optional trend indicator and tooltip
 * @param {Object} props - Component props
 * @param {string} props.label - Metric label/name
 * @param {string|number} props.value - Metric value to display
 * @param {number|null} props.trend - Optional trend percentage (positive/negative)
 * @param {string} props.tooltip - Tooltip text for additional context
 * @returns {JSX.Element} Metric card component
 */
const MetricCard = ({ label, value, trend = null, tooltip }) => (
    <div className="p-4 bg-gray-50 rounded-lg group relative">
        <div className="text-sm text-gray-600 mb-1">{label}</div>
        <div className="text-xl font-bold">{value}</div>
        {trend !== null && (
            <div className={`text-sm ${trend >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                {trend >= 0 ? '+' : ''}{trend.toFixed(1)}%
            </div>
        )}
        <div className="invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-opacity duration-300 absolute z-10 
            bg-gray-900 text-white text-xs rounded p-2 shadow-lg w-56 top-0 right-0">
            {tooltip}
        </div>
    </div>
);

export default MetricCard;
